import React from 'react'
import { Link } from 'react-router-dom'

import { Images } from '../../../ui/assets/images'

class RegisterSuccess extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { translate } = this.props
    return (
      <div className="account-page register-page register-success-page clearfix">
        <div className="wrapper-inner">
          <div className="box-info">
            <div className="row">
              <div className="info-left col-12 col-md-7 nopadding">
                <div className="info-title">
                  <ul>
                    <li>{translate('RegisterSuccess')}</li>
                  </ul>
                </div>
                <div className="info-content">
                  <div className="box-msg">
                    <div className="box-img"><img src={Images.logo} alt="" /></div>
                    <div className="box-info">Chúc mừng Quý khách đã đăng ký tài khoản đại lý thành công. Vui lòng liên hệ <a rel="noopener noreferrer" target="_blank" href="//tawk.to/chat/5e840db069e9320caabf1205/default?$_tawk_sk=6048d79b2affac39580751bf&$_tawk_tk=8dbd83d7cd9b6df305bd9aef3b33408b&v=698">CSKH</a> để được hỗ trợ duyệt tài khoản.</div>
                    <div className="box-link">
                      <Link className="btn" to="/"><span className="text-uppercase">{translate('Home')}</span></Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="info-right col-12 col-md-5 nopadding">
                <div className="orange-box">
                  <div className="box-title text-uppercase">Đăng ký đại lý Alo88 !</div>
                  <div className="box-highlight">Cùng biến đam mê thành lợi nhuận</div>
                  <ul>
                    <li><img src={Images.iconRegCheck} alt="" />&nbsp;&nbsp;&nbsp;100% đăng ký miễn phí</li>
                    <li><img src={Images.iconRegCheck} alt="" />&nbsp;&nbsp;&nbsp;50% chiết khấu hoa hồng</li>
                    <li><img src={Images.iconRegCheck} alt="" />&nbsp;&nbsp;&nbsp;Cam kết an toàn &amp; bảo mật</li>
                    <li><img src={Images.iconRegCheck} alt="" />&nbsp;&nbsp;&nbsp;Luôn thanh toán đúng hạn</li>
                  </ul>
                  <div className="box-img"><img src={Images.imgReg} alt="" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default RegisterSuccess
